import { render, staticRenderFns } from "./VLabel.vue?vue&type=template&id=34aed1ff"
import script from "./VLabel.vue?vue&type=script&lang=ts"
export * from "./VLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports